import { useEffect } from 'react'

import { trackOnboardingStepCompleted } from '@/utils/analytics'

export default function KycRedirectSuccess() {
  useEffect(() => {
    trackOnboardingStepCompleted('external_kyc_redirect')
    window.location.replace(
      `${window.location.protocol}//${window.location.hostname}/Complete24`
    )
  }, [])

  return (
    <div data-testid="container-kyc-redirect-success">
      <span data-testid="text-kyc-redirect-success-message">
        Redirecting to Paytrie. If you are not redirected automatically, click
        here:{' '}
      </span>
      <a
        style={{ textDecoration: 'underline' }}
        href={`${window.location.protocol}//${window.location.hostname}/Complete24`}
        data-testid="link-kyc-redirect-success-manual"
      >
        {window.location.protocol}//{window.location.hostname}/Complete24
      </a>
    </div>
  )
}
